import { render, staticRenderFns } from "./customerDailyrating.vue?vue&type=template&id=545fdb71&scoped=true"
import script from "./customerDailyrating.vue?vue&type=script&lang=js"
export * from "./customerDailyrating.vue?vue&type=script&lang=js"
import style0 from "./customerDailyrating.vue?vue&type=style&index=0&id=545fdb71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545fdb71",
  null
  
)

export default component.exports